module.exports = __webpack_public_path__ + "img/clock.db5f0229.png";